import React from 'react';
import { Link } from 'react-router-dom';
import { T } from './UI';

const WA = '353851234567';

export default function Footer() {
  return (
    <footer style={{ background: T.ink, color: T.bg, position: 'relative', overflow: 'hidden' }}>
      {/* Full-bleed atmosphere photo darkened */}
      <div style={{ position: 'relative', height: '60svh', minHeight: 340, overflow: 'hidden' }}>
        <img
          src="https://picsum.photos/id/955/1920/900"
          alt=""
          loading="lazy"
          width="1920" height="900"
          style={{ width: '100%', height: '100%', objectFit: 'cover', filter: 'brightness(0.38)', display: 'block' }}
        />
        {/* Top row — links & contact */}
        <div style={{ position: 'absolute', top: 32, left: 0, right: 0, paddingInline: 'var(--margin)', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 24 }}>
          <nav style={{ display: 'flex', gap: 28 }}>
            {[['Stock','/stock'],['Import','/import'],['About','/about'],['Contact','/contact']].map(([l,to]) => (
              <Link key={l} to={to} style={{ color: 'rgba(232,230,225,0.7)', fontSize: 'var(--step-sm)', letterSpacing: '0.02em', transition: 'color 0.15s' }}
                onMouseEnter={e => e.target.style.color = T.accent}
                onMouseLeave={e => e.target.style.color = 'rgba(232,230,225,0.7)'}>{l}</Link>
            ))}
          </nav>
          <div style={{ textAlign: 'right' }}>
            <a href="tel:+353851234567" style={{ display: 'block', color: 'rgba(232,230,225,0.7)', fontSize: 'var(--step-sm)', marginBottom: 4, transition: 'color 0.15s' }}
              onMouseEnter={e => e.target.style.color = T.accent}
              onMouseLeave={e => e.target.style.color = 'rgba(232,230,225,0.7)'}>+353 85 123 4567</a>
            <a href="mailto:info@northbridgeauto.ie" style={{ display: 'block', color: 'rgba(232,230,225,0.7)', fontSize: 'var(--step-sm)', transition: 'color 0.15s' }}
              onMouseEnter={e => e.target.style.color = T.accent}
              onMouseLeave={e => e.target.style.color = 'rgba(232,230,225,0.7)'}>info@northbridgeauto.ie</a>
          </div>
        </div>

        {/* Wordmark across the bottom */}
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, paddingInline: 'var(--margin)', paddingBottom: 20, overflow: 'hidden' }}>
          <div style={{ fontFamily: 'Playfair Display, serif', fontWeight: 700, fontSize: 'clamp(3.5rem, 10vw, 10rem)', color: T.bg, lineHeight: 0.88, letterSpacing: '-0.02em', opacity: 0.92, whiteSpace: 'nowrap' }}>
            Northbridge
          </div>
        </div>
      </div>

      {/* Legal strip */}
      <div style={{ paddingInline: 'var(--margin)', paddingBlock: 16, borderTop: `1px solid rgba(232,230,225,0.1)`, display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
        <p style={{ fontSize: 'var(--step-xs)', color: 'rgba(232,230,225,0.4)', letterSpacing: '0.04em' }}>
          © {new Date().getFullYear()} Northbridge Automotives Ltd. Dublin, Ireland
        </p>
        <div style={{ display: 'flex', gap: 20 }}>
          {['Privacy','Terms','Cookies'].map(l => (
            <a key={l} href="#" style={{ fontSize: 'var(--step-xs)', color: 'rgba(232,230,225,0.4)', transition: 'color 0.15s' }}
              onMouseEnter={e => e.target.style.color = T.bg}
              onMouseLeave={e => e.target.style.color = 'rgba(232,230,225,0.4)'}>{l}</a>
          ))}
        </div>
        <p style={{ fontSize: 'var(--step-xs)', color: 'rgba(232,230,225,0.25)', letterSpacing: '0.02em' }}>
          Atmosphere photos: Matt Benson, Andre Koch, Zugr, Lukas Schweizer — Unsplash licence
        </p>
      </div>
    </footer>
  );
}
